/* eslint-disable arrow-body-style */
// @flow
import React from 'react';
import Icon from '../../../_particles/icon/react/Icon';

const SearchFallBack = ({ link }: { link: string }): React$MixedElement => {
  return (
    <a
      href={link}
      className="header__icon"
      aria-labelledby="header-icon-label--search"
    >
      <Icon icon="search" ariaHidden={true} focusable={false} />

      <span id="header-icon-label--search" className="header__icon-text" hidden>
        Suche
      </span>
    </a>
  );
};

export default SearchFallBack;
